export const EVENTS = {
  // Core page views
  PAGE_VIEW: 'page_view',
  TODOS_PAGE_VIEW: 'todos_page_view',
  DEV_TODOS_PAGE_VIEW: 'dev_todos_page_view',
  GUESTBOOK_PAGE_VIEW: 'guestbook_page_view',
  GUESTBOOK_VIEW: 'guestbook_view',

  // Auth flows
  AUTH_SUCCESS: 'auth_success',
  AUTH_FAIL: 'auth_fail',
  TODOS_AUTH_SUCCESS: 'todos_auth_success',
  DEV_TODOS_AUTH_SUCCESS: 'dev_todos_auth_success',
  DEV_TODOS_AUTH_FAIL: 'dev_todos_auth_fail',

  // Navigation / view modes
  VIEW_MODE: 'view_mode',
  NAV: 'nav',

  // Content interactions
  TAG_CLICK: 'tag_click',
  GALLERY_OPEN: 'gallery_open',

  // Cards
  CARD_CLICK: 'card_click',

  // Guestbook
  GUESTBOOK_REPLY: 'guestbook_reply',
  GUESTBOOK_SUBMIT: 'guestbook_submit',

  // Media / assets
  PHOTO_LOAD_ERROR: 'photo_load_error',
};

